<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                @keyup.enter.native="SearchServiceList"
            ></el-input>
            <el-select
                v-model="search.status"
                clearable
                placeholder="状态"
            >
              <el-option
                  v-for="item in statusList"
                  :key="item.status"
                  :label="item.name"
                  :value="item.status"
              ></el-option>
            </el-select>
            <el-button size="medium" type="primary" @click="SearchServiceList"
            >查询
            </el-button
            >
          </template>

          <el-button v-if="addShow" size="medium" type="primary" @click="handleClick('add')"
          >新增
          </el-button>
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="customerServiceId"
              v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="50">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="descr" label="说明" min-width="120"></el-table-column>
            <el-table-column prop="seq" label="序号" width="50"></el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-switch
                    :disabled="statusShow"
                    :value="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="changeSwitch(scope.row)"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                    plain
                    v-if="editShow"
                    type="primary"
                    @click="handleClick('edit',scope.row)"
                    size="small"
                >编辑
                </el-button
                >
                <el-button
                    plain
                    v-if="deleteShow"
                    type="danger"
                    @click="handleDetail(scope.row)"
                    size="small"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 编辑弹框 -->
      <el-dialog
          title="新增/编辑塔罗类型"
          :visible.sync="dialogVisible"
          width="660px"
          top="30px"
          :close-on-click-modal="false"
          class="public-dialog"
      >
        <div class="public-dialog-form">
          <el-form
              ref="ruleForm"
              :rules="rules"
              :model="params"
              label-width="80px"
          >
            <el-form-item label="名称" prop="name">
              <el-input
                  placeholder="请填写名称"
                  v-model="params.name"
                  style="width: 234px"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型简介" prop="descr">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 4 }"
                  placeholder="请填写说明"
                  v-model="params.descr"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-switch
                  v-model="params.status"
                  :active-value="1"
                  :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <el-form-item label="排序" prop="seq">
              <el-input
                  placeholder="请填写排序"
                  v-model="params.seq"
                  style="width: 234px"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleSave"
        >提 交</el-button
        >
      </span>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import {
  PAGE_SIZE,
  COMPLIANT_TIMETYPE
} from "@/config";

import {formatMaxNum, formatMinNum, emptyShow} from "@utils/tools/index";

export default {
  data() {
    return {
      /* 函数 方法 */
      emptyShow, formatMaxNum, formatMinNum,
      /* 字段或数组 */
      PAGE_SIZE,
      COMPLIANT_TIMETYPE,
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
        count:0
      },
      tableData: [], //顶顶那列表
      loading: false,
      statusList: [
        {
          name: '已上架',
          status: 1
        },
        {
          name: '未上架',
          status: 0
        }
      ],
      search: {
        searchKey: '',
        status: ''
      },
      dialogVisible:false,
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        descr: [{ required: true, message: "请填写说明", trigger: "change" }],
        seq: [{ required: true, message: "请填写序号", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
      params:{},
      clickMode:'',
      sheetTarotCategoryId:'',

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },
  created() {
    this.queryStyleData();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'tarot:category:query') {
            this.searchShow = true
          }
          if (item.code == 'tarot:category:add') {
            this.addShow = true
          }
          if (item.code == "tarot:category:delete") {
            this.deleteShow = true
          }
          if (item.code == "tarot:category:edit") {
            this.editShow = true
          }
          if (item.code == "tarot:category:status") {
            this.statusShow = false
          }
        })
      }
    },

    handleDetail(row){
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/tarot/category/info/${row.tarotCategoryId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.queryStyleData();
        this.$message.success("删除成功!");
      });
    },
    //保存提交数据
    async  handleSave(){
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickMode == "add") {
            const { data: resData } = await this.$post(
                "/tarot/category/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.queryStyleData();
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.params = {};
          }
          if (this.clickMode=='edit') {
            const { data: resData } = await this.$put(
                "/tarot/category/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.queryStyleData();
            this.dialogVisible = false;
            this.$message.success("修改成功!");
          }
        });
      });
    },
    //操作按钮点击处理
    handleClick(e,item){
      this.clickMode = e
      if(e=='edit'){
        let tarotCategoryId = item.tarotCategoryId
        this.sheetTarotCategoryId = item.tarotCategoryId
        this.getInfo(tarotCategoryId)
      }else {
        this.dialogVisible = true
      }
    },
    async getInfo(e){
      this.loading = true;
      const {data: resData} = await this.$get("/tarot/category/info/"+e);
      this.loading = false;
      if (resData.result != 200) return;
      this.params = resData.data
      this.dialogVisible = true
    },
    //修改上下架状态
    async changeSwitch(e) {
      const {data: resData} = await this.$put(
          `tarot/category/info/status/${e.tarotCategoryId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (e.status) {
        e.status = 0
      } else {
        e.status = 1
      }
      this.$message({
        message: resData.message,
        type: "success",
      });
    },
    //获取分类列表
    async queryStyleData() {
      this.loading = true;
      const {data: resData} = await this.$get("/tarot/category/list", {
        params: {
          ...this.search,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if(resData.data){
        this.page.count = resData.page.count;
        this.tableData = resData.data.sort(function (a, b) {
          return b.seq - a.seq;
        });
      }else {
        this.page.count = 0;
        this.tableData = []
      }
    },
    //查询
    SearchServiceList() {
      this.page.pageNo = 1
      delete this.page['count']
      this.queryStyleData()
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
